module.exports = function() {
  return new Worker(__webpack_public_path__ + "d5301fcd739ff7bf6871.worker.js");
};